import { 
	Box, Typography, Grid, Stack, Divider,
	Accordion, AccordionDetails, AccordionSummary, 
	Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
 } from "@mui/material"
 import { ExpandMore } from "@mui/icons-material";
import { StoreContext } from "../../layout/HomeLayout/index";
import { useContext, useEffect, useState } from "react";
import { path } from "config/path";
import { useNavigate, useParams } from "react-router-dom";
import BookBtn from "components/ui/bookbtn";

const services = [
	{
		name: 'Hair Cut - Includes Shampoo, Blow dry',
		extra: 'For extra-long hair, there will be an additional charge of £5–£10',
		menus: [
			{
				name: 'hair cut',
				rows: [
					{ client: 'ladies-short/medium', prices: [70, 75, 85, 110] },
					{ client: 'ladies-long', prices: [75, 80, 90, 125] },
					{ client: 'gents-short/medium', prices: [55, 60, 65, 90] },
					{ client: 'gents-long', prices: [65, 70, 80, 100] },
					{ client: 'children-boys(Under 10)', prices: [50, 55, 60, 80] },
					{ client: 'children-girls(Under 10)', prices: [65, 70, 80, 90] },
					{ client: 'fringe-cut', prices: [25, 25, 25, 25] },
				],
			},
			{
				name: 'Haircut and Express Treatment',
				comments: 'System Professional ColorLock Emulsion Post-colour express treatment. Applied after shampoo, left for 5 minutes, it locks in pigments and boosts shine. System Professional Repair Emulsion Express repair treatment. After shampoo, leave for 5 minutes to strengthen, smooth, and protect damaged hair.',
				rows: [
					{ client: 'ladies-short/medium', prices: [100, 105, 115, 135] },
					{ client: 'ladies-long', prices: [105, 115, 125, 150] },
				],
			},
			{
				name: 'Haircut and Deep Treatment',
				comments: 'System Professional Repair Mask. A deep treatment for damaged and weak hair. It repairs the fiber, restores resilience, and improves elasticity, leaving hair smooth and resistant to breakage. For best results, apply and leave for about 15 minutes with heat or mist.',
				rows: [
					{ client: 'ladies-short/medium', prices: [115, 120, 130, 145] },
					{ client: 'ladies-long', prices: [125, 130, 150, 165] },
				],
			},
		],
	},
	{
		name: 'Head Spa',
		comments: 'Add a Head Spa treatment to any Chemical service for an additional £70',
		menus: [
			{
				name: 'Hair cut + Head Spa',
				rows: [
					{ client: 'ladies-short/medium', prices: [160, 165, 175, null] },
					{ client: 'ladies-long', prices: [175, 180, 200, null] },
					{ client: 'gents', prices: [135, 145, 165, null] },
				],
			},
			{
				name: 'Blow Dry + Head Spa',
				rows: [
					{ client: 'ladies-short/medium', prices: [135, 140, 145, null] },
					{ client: 'ladies-long', prices: [140, 145, 150, null] },
				],
			},
		],
	},
	{
		name: 'Styling',
		menus: [
			{
				name: 'Blow dry',
				rows: [
					{ client: 'short/medium', prices: [45, 50, 60, 75] },
					{ client: 'long', prices: [50, 55, 70, 85] },
				],
			},
			{
				name: 'Blowdry and Express treatment',
				rows: [
					{ client: 'short/medium', prices: [70, 75, 85, 100] },
					{ client: 'long', prices: [80, 85, 100, 115] },
				],
			},
			{
				name: 'Blowdry and Deep treatment',
				rows: [
					{ client: 'short/medium', prices: [90, 95, 100, 120] },
					{ client: 'long', prices: [100, 110, 115, 135] },
				],
			},
		],
	},
	{
		name: 'Colour - Includes Hair Cut And Blow dry',
		extra: 'For extra-long hair, there will be an additional charge of £50–£100',
		menus: [
			{
				name: 'Gents Tint',
				rows: [
					{ client: 'short', prices: [130, 140, 150, 160] },
					{ client: 'medium', prices: [145, 155, 165, 175] },
					{ client: 'long', prices: [155, 165, 175, 185] },
				],
			},
			{
				name: 'Ladies Tint',
				comments: 'A tint is a full-head colour applied once. Bleach and highlights are different services, so the pricing is separate.',
				rows: [
					{ client: 'short', prices: [160, 180, 190, 200] },
					{ client: 'medium', prices: [210, 220, 230, 240] },
					{ client: 'long', prices: [230, 250, 260, 270] },
				],
			},
			{
				name: 'Ladies Roots (Up to 1 inch re-growth)',
				rows: [
					{ client: 'short', prices: [155, 165, 175, 185] },
					{ client: 'medium', prices: [170, 180, 190, 200] },
					{ client: 'long', prices: [185, 195, 205, 215] },
				],
			},
			{
				name: 'Highlight-Half',
				comments: 'Foils applied to the top and sides. Creates noticeable lightness and dimension.',
				rows: [
					{ client: 'short', prices: [170, 180, 190, 200] },
					{ client: 'medium', prices: [195, 215, 225, 235] },
					{ client: 'long', prices: [220, 240, 250, 260] },
				],
			},
			{
				name: 'Highlight-Full',
				comments: 'Foils throughout the entire head. Provides the most complete and dramatic change.',
				rows: [
					{ client: 'short', prices: [200, 210, 215, 225] },
					{ client: 'medium', prices: [230, 245, 255, 275] },
					{ client: 'long', prices: [255, 270, 280, 300] },
				],
			},
			{
				name: 'Bleach H/L and Fashion Colour',
				rows: [
					{ client: 'short', prices: [310, 320, 330, 350] },
					{ client: 'medium', prices: [345, 375, 410, 435] },
					{ client: 'long', prices: [420, 440, 450, 460] },
				],
			},
			{
				name: 'Bleach and Fashion Colour',
				comments: 'Bleach and fashion colour services are priced to include one bleaching and one toning session. However, in some cases, a second bleaching may be required. If so, an additional charge of £100–£150 will apply.',
				rows: [
					{ client: 'short', prices: [280, 290, 300, 320] },
					{ client: 'medium', prices: [325, 345, 370, 395] },
					{ client: 'long', prices: [370, 390, 400, 420] },
				],
			},
			{
				name: 'Root Bleach and Fashion Colour',
				comments: 'This service includes one bleaching and one toning. However, in some cases a second bleaching may be required. If so, an additional charge of £80–£100 will apply.',
				rows: [
					{ client: 'short', prices: [230, 240, 250, 270] },
					{ client: 'medium', prices: [270, 290, 320, 350] },
					{ client: 'long', prices: [320, 340, 350, 370] },
				],
			},
		],
	},
	{
		name: 'Perm - Includes Hair Cut And Blow dry',
		extra: 'For extra-long hair, there will be an additional charge of £50–£80',
		comments: `Please note that clients with damaged hair, bleached hair will not be suitable for the  Perm service. If you have highlights or any type of colour treatment, we kindly ask that you email us with details of your hair condition along with photos, so that we can provide a proper consultation.

You can reach us at jubileehaircoventgarden@gmail.com, or visit our salon directly for an in-person consultation.`,
		menus: [
			{
				name: 'Gents Perm',
				rows: [
					{ client: 'short', prices: [135, 145, 165, 175] },
					{ client: 'medium', prices: [165, 175, 195, 210] },
					{ client: 'long', prices: [195, 210, 220, 240] },
				],
			},
			{
				name: 'Ladies Perm',
				comments: 'A classic perm done with chemical solution only, with heat. It creates stronger, tighter curls but often requires more daily styling.',
				rows: [
					{ client: 'short', prices: [200, 210, 220, 240] },
					{ client: 'medium', prices: [220, 230, 240, 260] },
					{ client: 'long', prices: [230, 250, 270, 280] },
				],
			},
			{
				name: 'Digital Perm',
				comments: 'A modern technique that uses both chemical solution and a heated machine. It creates soft, natural-looking waves that are easier to style and maintain.',
				rows: [
					{ client: 'short', prices: [230, 240, 250, 270] },
					{ client: 'medium', prices: [240, 250, 260, 280] },
					{ client: 'long', prices: [265, 275, 285, 295] },
				],
			},
			{
				name: 'Spiral Perm',
				rows: [
					{ client: 'short', prices: [280, 300, 320, 350] },
					{ client: 'medium', prices: [300, 320, 340, 370] },
					{ client: 'long', prices: [330, 350, 360, 380] },
				],
			},
			{
				name: 'Haircut + Fringe Perm',
				rows: [
					{ client: 'short/medium', prices: [125, 135, 145, 155] },
					{ client: 'long', prices: [130, 140, 160, 170] },
				],
			},
			{
				name: 'Haircut + Fringe Straightening Perm',
				rows: [
					{ client: 'short/medium', prices: [130, 140, 150, 160] },
					{ client: 'long', prices: [140, 150, 160, 180] },
				],
			},
			{
				name: 'Gents Cut & Down Perm',
				comments: 'A popular Korean men\'s style that smooths and flattens the sides and top where hair tends to stick out. It creates a cleaner, sharper look and helps the hairstyle stay in shape longer with less daily styling.',
				rows: [
					{ client: 'short', prices: [115, 125, 135, 150] },
					{ client: 'medium', prices: [135, 150, 165, 175] },
					{ client: 'long', prices: [160, 170, 175, 195] },
				],
			},
		],
	},
	{
		name: 'Magic Straightening - Includes Hair Cut And Blow dry',
		extra: 'For extra-long hair, there will be an additional charge of £50–£100',
		comments: `Please note that clients with damaged hair, bleached hair will not be suitable for the  Magic straightening service. If you have highlights or any type of colour treatment, we kindly ask that you email us with details of your hair condition along with photos, so that we can provide a proper consultation.

You can reach us at jubileehaircoventgarden@gmail.com, or visit our salon directly for an in-person consultation.`,
		menus: [
			{
				name: 'Gents Magic Straightening',
				rows: [
					{ client: 'short', prices: [170, 180, 190, 200] },
					{ client: 'medium', prices: [200, 210, 220, 230] },
					{ client: 'long', prices: [250, 260, 270, 280] },
				],
			},
			{
				name: 'Magic Straightening',
				comments: 'A popular Korean hair treatment that uses heat and special solutions to permanently straighten hair, leaving it smooth, shiny, and easy to manage.',
				rows: [
					{ client: 'short', prices: [280, 290, 300, 320] },
					{ client: 'medium', prices: [320, 340, 360, 390] },
					{ client: 'long', prices: [370, 390, 400, 440] },
				],
			},
			{
				name: 'Straightening + C & S Curl - Suitable for Frizzy Hair',
				comments: 'This service is especially suitable for clients with frizzy hair who want their hair straightened first and then styled with either a C-curl or an S-curl at the ends.',
				rows: [
					{ client: 'short', prices: [380, 390, 400, 420] },
					{ client: 'medium', prices: [420, 440, 460, 490] },
					{ client: 'long', prices: [460, 470, 490, 520] },
				],
			},
			{
				name: 'Yuko Anti-Frizz',
				comments: 'A smoothing treatment that reduces frizz, tames texture, and adds shine while keeping natural movement and volume.',
				rows: [
					{ client: 'short', prices: [280, 290, 300, 320] },
					{ client: 'medium', prices: [320, 340, 360, 390] },
					{ client: 'long', prices: [370, 390, 400, 440] },
				],
			},
		],
	},
	{
		name: 'Treatment',
		comments: 'Just Treatment does not include blow dry, additional charge is added on. However, for clients who are having cuts and chemical treatment, who also wish to have the hair treatment, the price which is shown above is added additionally.',
		menus: [
			{
				name: 'Express Treatment',
				rows: [
					{ client: 'short/medium', prices: [25, 25, 25, 25] },
					{ client: 'long', prices: [30, 30, 30, 30] },
				],
			},
			{
				name: 'Deep Treatment',
				rows: [
					{ client: 'short/medium', prices: [45, 45, 45, 45] },
					{ client: 'long', prices: [50, 50, 50, 50] },
				],
			},
			{
				name: 'Haircut and Express Treatment',
				rows: [
					{ client: 'short/medium', prices: [95, 100, 110, 120] },
					{ client: 'long', prices: [100, 110, 120, 130] },
				],
			},
			{
				name: 'Haircut and Deep Treatment',
				rows: [
					{ client: 'short/medium', prices: [110, 115, 120, 130] },
					{ client: 'long', prices: [120, 130, 140, 150] },
				],
			},
			{
				name: 'Blowdry and Express Treatment',
				rows: [
					{ client: 'short/medium', prices: [65, 70, 75, 80] },
					{ client: 'long', prices: [75, 80, 90, 100] },
				],
			},
			{
				name: 'Blowdry and Deep Treatment',
				rows: [
					{ client: 'short/medium', prices: [85, 90, 95, 100] },
					{ client: 'long', prices: [95, 100, 110, 120] },
				],
			},
		],
	},
];

const stylists = ['Stylist', 'Senior stylist', 'Top stylist', 'Director'];

const PriceTable = ({ rows }) => {
	if (rows.length<1) return (
		<Typography variant="h4" sx={{ pl:'2em', py:'1em'}}>Price : POA</Typography>
	);

	return (
		<TableContainer sx={{ pb: 2 }}>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell sx={{ fontWeight: 700 }}>&nbsp;</TableCell>
						{ stylists.map((stylist, index) => (
							<TableCell key={index} sx={{ fontWeight: 700, px:1 }} align="center">
								{stylist}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{ rows.map((row, index) => {
						return (
							<TableRow key={index}>
								<TableCell sx={{ fontWeight: 700, px:1 }}>{row.client}</TableCell>
								{ 
									row.prices.map((price, index) => 
										(
											<TableCell key={index} align="center">
												<Typography variant="body1" sx={{ 
													fontWeight:'800',
												}}>
													{price != null ? `£${price}` : 'POA'}
												</Typography>
											</TableCell>	
										)
									)
								}	
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

const PriceList = ({menus}) => {	
	return (
		<Stack>
			{menus.map((menu,index) => (
				<Box key={index} sx={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
					<Typography variant="h4" sx={{ pl:'0em'}}>&#9654; {menu.name}</Typography>
					{ menu.comments && <Typography>{menu.comments}</Typography> }
					<PriceTable rows={menu.rows} /> 
					{ menus.note && <Typography sx={{ fontSize:'1.5em', whiteSpace: "pre-wrap"}}>{menus.note}</Typography> }
				</Box>				
			))}
		</Stack>
	)
}

const Price = () => {
  return (
    <Box display='block' sx={{ p:'2em 1em', minHeight:600, '@media print': { minHeight: 'auto' } }}>
			<Box sx={{ textAlign:'center', px:'3.2em', '@media print': { display: 'none' } }}>
				<BookBtn />
			</Box>
      <Typography variant="h2">Our Services & Price</Typography>
      <Divider />
      <Stack width='100%'>
				<Box 
					component="img" 
					src={`${path.basename}/images/jubilee/hairlength.png`} 
					alt="hair length reference" 
					sx={{ 
						borderRadius: '12px',
						width: {
							xs: '100%',  // 모바일
							md: '50%'    // 데스크톱
						},
						height: 'auto'
					}}
				/>
				<Typography variant="h4">
					 Price Guide
				</Typography>
				<Typography variant="body1" sx={{ textAlign: "justify", pb:'1em', whiteSpace: "pre-wrap" }}>
					Please note that service prices may vary depending on hair length and thickness, as shown in the illustration and price chart below. Our team will confirm the exact cost with you during your consultation, before starting the service.
				</Typography>
			</Stack>
      <Stack width='100%'>
				{ services && 
					services.map((service, idx) => (
						<Stack key={idx} >
							<Typography variant="h2" sx={{
								textTransform:'capitalize',
								pt:'1em',
								pb:'0.5em',
								textDecoration:'underline',
								breakAfter: 'avoid',
								pageBreakAfter: 'avoid'
							}}>
								{service.name}
							</Typography>
							{
								service.extra &&
								<Typography variant="body1" sx={{
									fontStyle:'italic',
									pb:'0.5em',
									breakAfter: 'avoid',
									pageBreakAfter: 'avoid'
								}}>
									({service.extra})
								</Typography>
							}
							{
								service.comments &&
								<Typography variant="body1" sx={{
									fontSize:'1.7em',
									lineHeight:'1.2',
									pb:'1em',
									whiteSpace: "pre-wrap",
									breakAfter: 'avoid',
									pageBreakAfter: 'avoid'
								}}>
									{service.comments }
								</Typography>
							}
							<PriceList menus={service.menus} />
							{ service.note && <Typography sx={{ fontSize:'1.5em', whiteSpace: "pre-wrap"}}>{service.note}</Typography> }
						</Stack>
					))
				}
				<Box sx={{ '@media print': { breakBefore: 'page', pageBreakBefore: 'always' } }}>
				<Accordion disableGutters square sx={{
					breakInside: 'avoid',
					pageBreakInside: 'avoid',
					'@media print': {
						'& .MuiCollapse-root': { height: 'auto !important', visibility: 'visible !important' },
						'& .MuiAccordionDetails-root': { display: 'block !important' },
					},
				}}>
					<AccordionSummary expandIcon={<ExpandMore />}>
						<Typography variant="h3">Clients Notice</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Typography sx={{ textAlign: "justify" }} variant="body1">
							Our salon’s pricing is generally structured by stylist level – Stylist, Senior, Top, and Director. However, even within the same level, there may be slight variations in price. This reflects each stylist’s individual strengths and areas of expertise.
						</Typography>
					</AccordionDetails>
				</Accordion>

				<Accordion disableGutters square sx={{
					breakInside: 'avoid',
					pageBreakInside: 'avoid',
					'@media print': {
						'& .MuiCollapse-root': { height: 'auto !important', visibility: 'visible !important' },
						'& .MuiAccordionDetails-root': { display: 'block !important' },
					},
				}}>
					<AccordionSummary expandIcon={<ExpandMore />}>
						<Typography variant="h3">Cancellation Policy</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Typography sx={{ textAlign: "justify" }} variant="body1" fontWeight="500">
							Please note that for Colour and Perm, as well as all chemical treatment services, cancellations or rescheduling must be made at least 48 hours in advance, and for Haircuts, 24 hours in advance. In the case of late cancellations or late rescheduling, we will charge 35% of the total service price for Colour, Perm, and other chemical treatments, and 50% for Haircuts, to the card you provided at the time of booking.
							<br />
							If you’ve booked a Colour and Perm service, we kindly ask that you reply to the email we send. This consultation is important to ensure your hair is in the best condition for the service. If we don’t receive a response and are unable to proceed due to prior hair damage from colour or perm, 35% of the deposit will still be charged.
							<br/>
						</Typography>
					</AccordionDetails>
				</Accordion>
				</Box>
			</Stack>
    </Box>
  );
};

export default Price;